<app-header-top *ngIf="!isPopup" [title]="isNew ? 'Nuovo punto vendita' : 'Impostazioni punto vendita'"></app-header-top>

<div class="container mt-3">

   <form class="with-label">
      <div class="col-span-12 lg:col-span-6" *ngIf="!isNew">
         <mat-label>Priorità di prelievo</mat-label>
         <mat-form-field appearance="fill" class="w-full">
            <mat-select (selectionChange)="setPrioritaPrelievo($event.value)" [formControl]="index_pri">
               <mat-option value="">Seleziona un'opzione</mat-option>
               <mat-option *ngFor="let pv of this.puntiVendita" value="{{pv.ID}}">Priorità: {{pv.data.index_pri}} - {{pv.data.nome}}</mat-option>
            </mat-select>
         </mat-form-field>
      </div>
   </form>

   <form class="with-label" [formGroup]="frmGrpPV" autocomplete="off">

      <div class="grid grid-cols-12 gap-4 pb-0">
         <div class="col-span-12 lg:col-span-12">
            <mat-label>Insegna</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="text" formControlName="nome">
               <mat-error *ngIf="frmGrpPV.get('nome')?.hasError('required')">
                  Nome Insegna obbligatoria
               </mat-error>
            </mat-form-field>
         </div>

         <!--         <div class="col-span-6 lg:col-span-3">-->
         <!--            <mat-label>Indice</mat-label>-->
         <!--            <mat-form-field class="w-full" appearance="fill">-->
         <!--               <input matInput type="number" formControlName="index">-->
         <!--               <mat-error *ngIf="frmGrpPV.get('index')?.hasError('required')">-->
         <!--                  Indice obbligatorio-->
         <!--               </mat-error>-->
         <!--            </mat-form-field>-->
         <!--         </div>-->




         <div class="col-span-12 mb-5">
            <div class="flex flex-wrap gap-4">
               <mat-checkbox class="mr-3" color="primary" formControlName="aperto_pubblico">Aperto al pubblico</mat-checkbox>
               <!--               <mat-checkbox class="mr-3" color="primary" formControlName="is_virtual">Punto vendita virtuale</mat-checkbox>-->
            </div>
         </div>

         <div formGroupName="indirizzo" class="col-span-12">
            <div class="grid grid-cols-12 gap-4">

               <div class="col-span-12 lg:col-span-3">
                  <mat-label>Seleziona uno stato</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <mat-select (selectionChange)="setValueStato($event.value)" formControlName="stato">
                        <mat-option value="">Seleziona un'opzione</mat-option>
                        <mat-option *ngFor="let stato of this.arrStati" value="{{stato.data.id}}">{{stato.data.nome}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('stato')?.hasError('required')">
                        Inserisci lo stato
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-12 lg:col-span-3">
                  <mat-label>Seleziona una regione</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <mat-select (selectionChange)="setValueProvince($event.value)" formControlName="regione">
                        <mat-option value="">Seleziona un'opzione</mat-option>
                        <mat-option *ngFor="let regione of this.arrRegioni" value="{{regione.data.id}}">{{regione.data.nome}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('regione')?.hasError('required')">
                        Inserisci la regione
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-12 lg:col-span-3">
                  <mat-label>Seleziona una provincia</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <mat-select (selectionChange)="setValueCitta($event.value)" formControlName="provincia">
                        <mat-option value="">Seleziona un'opzione</mat-option>
                        <mat-option *ngFor="let provincia of this.arrProvince" value="{{provincia.data.id}}">{{provincia.data.nome}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('provincia')?.hasError('required')">
                        Inserisci la provincia
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-12 lg:col-span-3">
                  <mat-label>Seleziona una città</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <mat-select formControlName="citta">
                        <mat-option value="">Seleziona un'opzione</mat-option>
                        <mat-option *ngFor="let citta of this.arrCitta" value="{{citta.data.id}}">{{citta.data.nome}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('citta')?.hasError('required')">
                        Inserisci la citta
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-12 lg:col-span-6">
                  <mat-label>Indirizzo</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <input matInput type="text" formControlName="indirizzo">
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('indirizzo')?.hasError('required')">
                        Via obbligatoria
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-12 lg:col-span-3">
                  <mat-label>Numero civico</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <input matInput type="text" formControlName="civico">
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('civico')?.hasError('required')">
                        civico obbligatorio
                     </mat-error>
                  </mat-form-field>
               </div>

               <div class="col-span-12 lg:col-span-3">
                  <mat-label>CAP</mat-label>
                  <mat-form-field appearance="fill" class="w-full">
                     <input matInput type="text" formControlName="cap" maxlength="5">
                     <mat-error *ngIf="frmGrpPV.get('indirizzo')?.get('cap')?.hasError('required')">
                        Cap obbligatorio
                     </mat-error>
                  </mat-form-field>
               </div>

            </div>
         </div>

         <div class="col-span-12 lg:col-span-1">
            <mat-label>Prefisso</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="text" formControlName="prefisso" >
               <mat-error *ngIf="frmGrpPV.get('prefisso')?.hasError('required')">
                  prefisso obbligatorio
               </mat-error>
            </mat-form-field>
         </div>

         <div class="col-span-12 lg:col-span-5">
            <mat-label>Telefono</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="text" formControlName="telefono" >
               <mat-error *ngIf="frmGrpPV.get('telefono')?.hasError('required')">
                  Telefono obbligatorio
               </mat-error>
            </mat-form-field>
         </div>

         <div class="col-span-12 lg:col-span-6">
            <mat-label>Email</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <input matInput type="email" formControlName="email" >
               <mat-error *ngIf="frmGrpPV.get('email')?.hasError('required')">
                  Email obbligatoria
               </mat-error>
               <mat-error *ngIf="frmGrpPV.get('email')?.hasError('email')">
                  Email non valida
               </mat-error>
            </mat-form-field>
         </div>

      </div>

      <div class="pulsantiera" *ngIf="!isPopup">
         <button class="ds-btn ds-btn-info"
                 [disabled]="is_disabled"
                 *ngIf="!isNew"
                 (click)="clickEditPVendita()">
            Salva punto vendita
         </button>

         <button class="ds-btn ds-btn-info"
                 *ngIf="isNew"
                 (click)="clickCreatePVendita()">
            Crea punto vendita
         </button>
      </div>

   </form>

</div>
